<template>
    <IntegrationStoreSettingsLayout @save="saveAndContinue"
                                    @cancel="preventLeavingWithUnsavedChanges"
                                    :disable-save="!config.isDirty && config.ph_branch === null"
    >
        <Alert v-if="loadingBranchesFailed"
               :title="__(`integrations.${integration.code}.loading_branches_failed_title`)"
               type="light-danger"
               class="mb-6"
        >
            <template v-slot:icon>
                <i class="fas fa-exclamation-triangle"/>
            </template>
            <template v-slot:default>
                {{ __(`integrations.${integration.code}.loading_branches_failed`) }}
            </template>
        </Alert>

        <!-- BRANCH ID -->
        <FormGroupNew :label="__('general.store_branch')"
                      :description="__('actions.select_thing', {thing: __('general.store_branch')})"
                      :error="config.errors.ph_branch"
                      :required="requiredFields.includes('ph_branch')">
            <div v-if="loading" class="text-primary">
                <div class="spinner spinner-xs spinner-primary d-inline-block mr-5"/>
                {{ __('general.things.are_being_loaded', {things: __('general.store_branches')}) }}...
            </div>
            <div v-if="!loading && proHandelBranches.length === 0" class="text-warning user-select-none">
                <i class="fas fa-exclamation-triangle"/>
                {{ __('general.things.none_found', {things: __('general.store_branches')}) }}
            </div>
            <RadioGroup v-if="!loading && radioGroupOptions"
                        :options="radioGroupOptions"
                        v-model="config.ph_branch"
            />
        </FormGroupNew>
    </IntegrationStoreSettingsLayout>
</template>

<script>
import IntegrationStoreSettingsLayout from "@layouts/IntegrationStoreSettingsLayout.vue";
import IntegrationStoreConfigMixin from "@mixins/IntegrationStoreConfigMixin";
import FormGroupNew from "@components/Form/FormGroupNew.vue";
import IntegrationRoutesMixin from "@mixins/IntegrationRoutesMixin";
import RadioGroup from "@components/Inputs/RadioGroup.vue";
import Alert from "@components/Alert.vue";

export default {
    components: {
        Alert,
        RadioGroup,
        FormGroupNew,
        IntegrationStoreSettingsLayout,
    },

    mixins: [IntegrationStoreConfigMixin, IntegrationRoutesMixin],

    data() {
        return {
            proHandelBranches: [],
            loading: true,
            loadingBranchesFailed: false
        }
    },

    mounted() {
        this.loadProHandelBranches();
    },

    methods: {
        loadProHandelBranches() {
            this.loading = true;
            axios.post(this.integrationRoute('branches'), {
                firebase_uid: this.$page.props.user.firebase_uid
            })
                .then(response => {
                    this.proHandelBranches = response.data;
                    this.loading = false;
                })
                .catch(errorResponse => {
                    logDev('Error loading ProHandel branches.', errorResponse.response.data)
                    this.loadingBranchesFailed = true;
                    this.loading = false;
                })
        }
    },

    computed: {
        radioGroupOptions() {
            let options = {};

            for (let store of this.proHandelBranches) {
                options[`(${store.id}) ${store.name1}, ${store.zipCode} ${store.city}, ${store.street}`] = store.number;
            }

            return options;
        }
    }
}
</script>
